import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { formatMoneyCents } from "@/core/utils/money";

interface TechnicianAdjustmentLineProps {
  jobNumber: string | null;
  amountCents: number;
  category: string;
  memo: string | null;
  alreadyPushed?: boolean;
}

export const TechnicianAdjustmentLine = ({
  jobNumber,
  amountCents,
  category,
  memo,
  alreadyPushed = false,
}: TechnicianAdjustmentLineProps) => (
  <Stack
    align="start"
    gap={1}
    className="w-full border-b border-line pb-3 last:border-0"
  >
    <Stack direction="row" align="center" justify="between" gap={2}>
      <Text className="font-medium">
        {jobNumber ? `Job ${jobNumber}` : "No job number"}
      </Text>
      <Text className="shrink-0 font-medium">
        {formatMoneyCents(amountCents) ?? "$0"}
      </Text>
    </Stack>
    <Stack direction="row" align="center" gap={2}>
      <Text variant="caption" tone="muted" className="capitalize">
        {category.replace(/_/g, " ")}
      </Text>
      {alreadyPushed && (
        <Badge variant="secondary" color="warning" size="sm">
          Pushed
        </Badge>
      )}
    </Stack>
    {memo && (
      <Text variant="caption" tone="muted" className="wrap-break-word">
        {memo}
      </Text>
    )}
  </Stack>
);
